import { Component, inject } from '@angular/core';
import { Button } from 'primeng/button';
import { FormsModule } from '@angular/forms';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { TextareaModule } from 'primeng/textarea';
import { PdfService } from '../../service/pdf.service';

@Component({
  selector: 'app-modal-description-publish',
  standalone: true,
  imports: [Button, FormsModule, TextareaModule],
  templateUrl: './modal-description-publish.component.html',
  styleUrl: './modal-description-publish.component.scss',
})
export class ModalDescriptionPublishComponent {
  refDialogService = inject(DynamicDialogRef);
  configDialogService = inject(DynamicDialogConfig);
  pdfService = inject(PdfService);

  // parametros
  idfdArchivo = 0;
  description = '';

  constructor() {
    this.idfdArchivo = this.configDialogService.data;
  }

  async onConfirmar() {
    // Si todo sale bien muestra la ventana de previsualización
    await this.pdfService.publish(this.idfdArchivo, this.description);
    // Manda a cerrar la ventana actual
    this.refDialogService.close(true);
  }

  onCancelar() {
    this.refDialogService.close(false);
  }
}
